<template lang="pug">
  v-row(no-gutters)
    v-col(cols="8")
      div.label.basic600--text.text-uppercase {{ $t('enter_individual') }} {{ header1 }}
    v-col
      div.c1.basic600--text.text-right {{ header2 }}
</template>

<script>
export default {
  name: 'BundleBunkIndividualHeader',
  props: {
    selectedSetting: {
      type: String,
      required: true
    }
  },
  computed: {
    header1() {
      switch (this.selectedSetting) {
        case 'price':
          return this.$t('prices')

        case 'weight':
          return this.$t('weights')

        case 'inventory':
          return this.$t('stocks')

        default:
          return false
      }
    },
    header2() {
      switch (this.selectedSetting) {
        case 'price':
          return this.$t('price_currency')

        case 'weight':
          return this.$t('additional_weight')

        case 'inventory':
          return this.$t('available_bundles')

        default:
          return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>

<i18n>
{
  "en": {
    "enter_individual": "Enter individual",
    "prices": "prices",
    "weights": "weights",
    "stocks": "stocks",
    "price_currency": "Price (RM)",
    "additional_weight": "Additional weight (kg)",
    "available_bundles": "Available bundles"
  },
  "id": {
    "enter_individual": "Masukkan individu",
    "prices": "harga",
    "weights": "berat",
    "stocks": "saham",
    "price_currency": "Harga (RM)",
    "tambahan_berat": "Berat tambahan (kg)",
    "available_bundles": "Paket yang tersedia"
  }
}
</i18n>